export function getMobileOS() {
  var _navigator;
  if (typeof window === 'undefined') return null;
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var isTouchScreen = ((_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.maxTouchPoints) && navigator.maxTouchPoints > 0;
  if (/windows phone/i.test(userAgent)) {
    return 'windows';
  }
  if (/android/i.test(userAgent) && isTouchScreen && !window.MSStream) {
    return 'android';
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  // upd 2025: added iPad Pro (1366 x 1024) detection from https://stackoverflow.com/a/64559209
  if ((/iPad|iPhone|iPod/.test(userAgent) || isTouchScreen && /Mac/.test(navigator.platform)) && !window.MSStream) {
    return 'ios';
  }
  return false;
}